import LawnetLogo from "../../../assets/images/LAWNET LOGO.png";
import { useState } from "react";
import api from "../../../services/baseUrl";
const UploadDocument = () => {
  const [paymentType, setPaymentType] = useState("LO/PO");
  const [formData, setFormData] = useState({
    organizationName: "",
    number: "",
    email: "",
    amount: "",
    note: "",
    file: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      setFormData((prev) => ({ ...prev, file: e.target.files[0] }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append("paymentType", paymentType);
    formDataToSend.append("organizationName", formData.organizationName);
    formDataToSend.append("number", formData.number);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("note", formData.note);
    if (paymentType === "Invoice Payment") {
      formDataToSend.append("amount", formData.amount);
    }
    if (formData.file) {
      formDataToSend.append("file", formData.file);
    }

    try {
      const response = await api.post(
        "/api/payment/upload-document",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        alert("File uploaded successfully!");
        setFormData({
          organizationName: "",
          number: "",
          email: "",
          amount: "",
          note: "",
          file: null,
        });
      } else {
        alert("Error uploading file. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to upload. Please check your network.");
    }
  };
  return (
    <div className="payment-body">
      <div className="payment-container">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img height={60} src={LawnetLogo} alt="" />
        </div>
        <h2>Upload Payment Document</h2>

        {/* File Upload */}
        <div className="form-group">
          <label>Upload File:</label>
          <input type="file" onChange={handleFileChange} />
        </div>

        {/* Radio Group */}
        <div className="radio-group">
          <label>Payment Type:</label>
          <label>
            <input
              type="radio"
              value="LO/PO"
              checked={paymentType === "LO/PO"}
              onChange={(e) => setPaymentType(e.target.value)}
            />
            {"  "}LO/PO
          </label>
          <label>
            <input
              type="radio"
              value="Invoice Payment"
              checked={paymentType === "Invoice Payment"}
              onChange={(e) => setPaymentType(e.target.value)}
            />
            {"  "}Invoice Payment
          </label>
        </div>

        {/* Common Fields */}
        <div className="form-group">
          <label>Organization Name:</label>
          <input
            type="text"
            name="organizationName"
            value={formData.organizationName}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label>
            {paymentType === "LO/PO" ? "LO/PO Number:" : "Invoice Number:"}
          </label>
          <input
            type="text"
            name="number"
            value={formData.number}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label>Email Address:</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
        </div>

        {paymentType === "Invoice Payment" && (
          <div className="form-group">
            <label>Amount:</label>
            <input
              type="number"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
            />
          </div>
        )}

        <div className="form-group">
          <label>Note:</label>
          <textarea
            name="note"
            value={formData.note}
            onChange={handleChange}
          ></textarea>
        </div>

        <button onClick={handleSubmit} className="login-button" type="submit">
          Submit
        </button>
      </div>
    </div>
  );
};

export default UploadDocument;
